import * as Yup from 'yup';
import { DictionaryRiverSide } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryRiverSide>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
